import React from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { pxTransform } from "@tarojs/taro";
import type { StandardLonghandProperties } from "csstype";

import { XHComponentCommonProps } from "../../types";

import "./index.scss";

export type ProgressProps = {
  percent: number;
  showPercent?: boolean;
  doneColor?: string;
  percentColor?: string;
  height?: number;
  /**
   * @description 百分比，不要百分号
   */
  dots?: number[];
  /**
   * 苗条模式
   */
  solid?: boolean;
  backgroundColor?: StandardLonghandProperties["color"];
} & XHComponentCommonProps;

const Progress: React.FC<ProgressProps> = props => {
  const {
    percent = 88,
    className,
    showPercent = false,
    doneColor = "",
    percentColor = "",
    height = 28,
    dots = [],
    solid = false,
    backgroundColor = "",
  } = props;
  const progresslcs = classNames("xh-progress", className, {
    dots: dots.length > 0,
  });

  const showPercentcls = classNames(
    "progress-bar",
    { dots: dots.length > 0 },
    { solid },
    { h5: process.env.TARO_ENV === "h5" }
  );
  const showbarPercentcls = classNames("progress-bar-percent", { solid });
  return (
    <View
      className={progresslcs}
      style={{
        height: height && pxTransform(height),
      }}
    >
      <View
        className={classNames("progress", { solid })}
        style={{ backgroundColor }}
      >
        {dots.length > 0 ? (
          <React.Fragment>
            {dots.map(item => (
              <View
                style={{
                  width: `${item}%`,
                }}
                key={item}
                data-progress={item}
                className={showPercentcls}
              >
                {process.env.TARO_ENV !== "h5" && (
                  <View className="progress-bar-text">{item}%</View>
                )}
              </View>
            ))}
            <View className="progress-cover" style={{ width: `${percent}%` }} />
          </React.Fragment>
        ) : (
          <View
            style={{
              width: `${percent}%`,
              backgroundColor: doneColor,
              color: percentColor,
            }}
            className={showPercentcls}
          >
            {showPercent && (
              <View className={showbarPercentcls}>{`${percent}%`}</View>
            )}
          </View>
        )}
      </View>
    </View>
  );
};

export default Progress;
